import { checkResolution } from '../tools/helpers';

export class rStickySidebar {
    constructor({
        holderSelector,
        options = {},
    }) {
        this.holderEl = document.querySelector(holderSelector);
        this.options = options;
        this.stickySidebarInstance = null;

        this.updateSticky = this.updateSticky.bind(this);
    }

    async init() {
        if (!this.holderEl) {
            console.warning('Filter sidebar holder element not found')
            return
        }

        // dynamic import, only when needed
        const { default: stickySidebar } = await import('sticky-sidebar')

        this.stickySidebarInstance = new stickySidebar(
            this.holderEl,
            {
                ...{
                    topSpacing: this.calculateTopSpacing(),
                    bottomSpacing: 16,
                },
                ...this.options,
            }
        );

        this.attachUpdates();
    }

    attachUpdates() {
        setTimeout(() => this.updateSticky(), 100)
        setTimeout(() => this.updateSticky(), 1000)

        document.addEventListener('DOMContentLoaded', this.updateSticky);

        rEvent.on('Filter.submitted', this.updateSticky);
        rEvent.on('Listing.fetchedData', this.updateSticky);

        for (const rMoreItemsEl of this.holderEl.querySelectorAll('r-more-items')) {
            rMoreItemsEl.addEventListener('rMoreItems.after.expand', this.updateSticky)
            rMoreItemsEl.addEventListener('rMoreItems.after.collapse', this.updateSticky)
        }

        for (const rTabsEl of this.holderEl.querySelectorAll('r-tabs')) {
            rTabsEl.addEventListener('rTab.after.closeAllTabs', this.updateSticky)
            rTabsEl.addEventListener('rTab.after.closeTab', this.updateSticky)
            rTabsEl.addEventListener('rTab.after.openTab', this.updateSticky)
        }
    }

    updateSticky() {
        if (!this.stickySidebarInstance) return

        console.log('updateSticky')

        this.updateTopSpacing()
        this.stickySidebarInstance.updateSticky();

        setTimeout(() => {
            this.updateTopSpacing()
            this.stickySidebarInstance.updateSticky();
        }, 15)
    }

    updateTopSpacing() {
        this.stickySidebarInstance.options.topSpacing = this.calculateTopSpacing();
    }

    /**
     * Not optimized for header shrinkage
     *
     * Also this function will probably be project specific,
     * so maybe we can make some basic functionality here,
     * and then override it in the project, in setup, like:
     *
     * const stickySidebar = new rStickySidebar({
     *   options: {
     *     ...
     *   },
     *   calculateTopSpacing() {
     *     ... custom logic ...
     *   }
     * });
     */
    calculateTopSpacing() {
        let headerHeight

        if (checkResolution('cxs;txs')) {
            headerHeight = 121;
        } else if (checkResolution('xs;sm')) {
            headerHeight = 131;
        } else if (checkResolution('md;lg')) {
            headerHeight = 124;
        }

        let topSpacing = headerHeight;
        const infoMessage = document.querySelector('.js-info-message');

        if (infoMessage && infoMessage.style.display !== 'none') {
            topSpacing += infoMessage.offsetHeight;
        }

        topSpacing += 16;

        return topSpacing;
    }
}